import React from 'react';
import { Link } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const footerLinks = [
	{ label: 'O mnie', href: '/about-me' },
	{ label: 'Oferta', href: '/offer' },
	{ label: 'Trening', href: '/training' },
	{ label: 'Opinie', href: '/opinions' },
	{ label: 'Kontakt', href: '/contact' },
	{ label: 'FAQ', href: '/faq' },
	{ label: 'Blog', href: '/blog' },
];

export const Footer = () => {
	return (
		<footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
			<div className="max-w-7xl mx-auto px-6 py-16">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
					<div className="lg:col-span-1">
						<img
							src="/amelia-palczynska-logo.png"
							alt="Amelia Pałczyńska"
							className="w-20 h-20 mb-4 brightness-0 invert"
						/>
						<h3 className="text-xl font-playfair-custom-bold mb-2">
							Amelia Pałczyńska
						</h3>
						<p className="text-gray-400 font-montserrat-custom-medium text-sm">
							Trenerka personalna kobiet
						</p>
						<p className="text-gray-400 font-montserrat-custom-medium text-sm mt-4 leading-relaxed">
							Pomogę Ci osiągnąć wymarzoną sylwetkę i poprawić komfort codziennego życia.
						</p>
					</div>

					<div>
						<h4 className="text-lg font-bold mb-6 text-primary-400">
							Nawigacja
						</h4>
						<ul className="space-y-3">
							{footerLinks.map(({ label, href }) => (
								<li key={href}>
									<Link
										to={href}
										className="text-gray-400 hover:text-white transition-colors duration-200 font-montserrat-custom-medium text-sm"
									>
										{label}
									</Link>
								</li>
							))}
						</ul>
					</div>

					<div>
						<h4 className="text-lg font-bold mb-6 text-primary-400">
							Kontakt
						</h4>
						<ul className="space-y-4">
							<li>
								<a
									href="tel:508871292"
									className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors duration-200 font-montserrat-custom-medium text-sm"
								>
									<PhoneIcon className="text-primary-400" fontSize="small" />
									508 871 292
								</a>
							</li>
							<li>
								<a
									href="mailto:ameliapalczynska6@gmail.com"
									className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors duration-200 font-montserrat-custom-medium text-sm"
								>
									<EmailIcon className="text-primary-400" fontSize="small" />
									ameliapalczynska6@gmail.com
								</a>
							</li>
							<li>
								<a
									href="https://www.instagram.com/amelia_palczynska"
									target="_blank"
									rel="noopener noreferrer"
									className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors duration-200 font-montserrat-custom-medium text-sm"
								>
									<InstagramIcon className="text-primary-400" fontSize="small" />
									@amelia_palczynska
								</a>
							</li>
							<li className="flex items-start gap-3 text-gray-400 font-montserrat-custom-medium text-sm">
								<LocationOnIcon className="text-primary-400 mt-0.5 flex-shrink-0" fontSize="small" />
								<span>Studio Sportu Dual<br />Aleja Wincentego Witosa 11 A, 35-115 Rzeszów</span>
							</li>
						</ul>
					</div>

					<div>
						<h4 className="text-lg font-bold mb-6 text-primary-400">
							Rozpocznij
						</h4>
						<p className="text-gray-400 font-montserrat-custom-medium text-sm mb-6">
							Gotowa/y na zmianę? Zapisz się na konsultację!
						</p>
						<Link
							to="/contact"
							className="inline-block px-8 py-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-bold rounded-full shadow-soft hover:shadow-soft-lg hover:scale-105 transition-all duration-300 text-sm"
						>
							ZAPISZ SIĘ
						</Link>
					</div>
				</div>

				<div className="mt-16 pt-8 border-t border-gray-700">
					<div className="flex flex-col md:flex-row justify-between items-center gap-4">
						<p className="text-gray-500 text-sm font-montserrat-custom-medium">
							© {new Date().getFullYear()} Amelia Pałczyńska. Wszystkie prawa zastrzeżone.
						</p>
						<div className="flex gap-4">
							<a
								href="https://www.instagram.com/amelia_palczynska"
								target="_blank"
								rel="noopener noreferrer"
								className="w-10 h-10 rounded-full bg-gray-700 hover:bg-primary-500 flex items-center justify-center transition-all duration-300 hover:scale-110"
							>
								<InstagramIcon fontSize="small" />
							</a>
							<a
								href="mailto:ameliapalczynska6@gmail.com"
								className="w-10 h-10 rounded-full bg-gray-700 hover:bg-primary-500 flex items-center justify-center transition-all duration-300 hover:scale-110"
							>
								<EmailIcon fontSize="small" />
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
